import { render } from "./Legal_Notice.vue?vue&type=template&id=92c43abc"
import script from "./Legal_Notice.vue?vue&type=script&lang=js"
export * from "./Legal_Notice.vue?vue&type=script&lang=js"

import "./Legal_Notice.vue?vue&type=style&index=0&id=92c43abc&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__